import { Paragraph } from "@george-labs.com/design-system"
import { IndividualDTO } from "@smartx/mikro-vt-client-api"
import { compact, find } from "lodash-es"
import { useTranslation } from "react-i18next"
import CollapsibleComponent from "../../../components/Collapsible/Collapsible"
import DataList, { IField } from "../../../components/DataList/DataList"
import { getAddress } from "../../../functions/getAddress"

interface OverviewIndividualsProps {
  individualData: IndividualDTO[]
}

const OverviewIndividuals: React.FC<OverviewIndividualsProps> = ({
  individualData,
}) => {
  const { t } = useTranslation()

  const getIdentifierDocument = (
    identifierDocuments: any,
    documentTypes: Array<string>,
  ) => {
    let result: any
    identifierDocuments = compact(identifierDocuments)

    documentTypes.forEach((docType) => {
      if (!result) {
        const doc = find(identifierDocuments, { idType: docType })
        if (doc) {
          result = doc
        }
      }
    })
    return result
  }

  const getFieldArr = (individual: IndividualDTO) => {
    const fieldArr: Array<IField> = []

    const identifierDocument = getIdentifierDocument(
      individual.identifierDocuments,
      [
        "NIC",
        "KVE",
        "PPT",
        "FIN",
        "LCK",
        "ZNYI",
        "ZBRN",
        "ZOSI",
        "ZAOH",
        "ZNIC",
        "ZKVE",
        "ZPPT",
        "ZFIN",
        "ZLCK",
      ],
    )

    fieldArr.push(
      {
        label: t("case.fields.symbolsId"),
        value: individual?.symbolsId,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.name"),
        value: individual?.name,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.birthName"),
        value: individual?.birthName,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.birthPlace"),
        value: individual?.birthPlace,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.birthDate"),
        value: individual?.birthDate,
        fieldType: "date",
      },
      {
        label: t("case.fields.individual.nationality"),
        value: individual?.nationality,
        fieldType: "CVT",
        list: "MIKRO_COUNTRY_LIST",
      },
      {
        label: t("case.fields.individual.motherBirthName"),
        value: individual?.motherBirthName,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.idType"),
        value: identifierDocument?.idType,
        fieldType: "CVT",
        list: "MIKRO_ID_TYPE_LIST",
      },
      {
        label: t("case.fields.individual.idValue"),
        value: identifierDocument?.idValue,
        fieldType: "CVT",
        list: "MIKRO_ID_TYPE_LIST",
      },
      {
        label: t("case.fields.individual.taxIdNo"),
        value: individual?.taxIdNo,
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.address"),
        value: getAddress(individual?.addresses, "PERMANENT"),
        fieldType: "text",
      },
      {
        label: t("case.fields.individual.phoneNumber"),
        value: individual?.phoneNumber,
        fieldType: "phone",
      },
      {
        label: t("case.fields.individual.emailAddress"),
        value: individual?.emailAddress,
        fieldType: "text",
      },
    )

    return <DataList dataList={fieldArr} />
  }

  return (
    <>
      {individualData?.length === 0 && (
        <Paragraph className="text-center g-fg-ui-yellow p-3">
          {t("case.overview.warnings.noIndividuals")}
        </Paragraph>
      )}
      {individualData?.length > 0 &&
        individualData?.map((individual: IndividualDTO) => {
          return (
            <CollapsibleComponent
              titleString={individual?.name}
              key={`individual-${individual?.symbolsId}`}
              content={<>{getFieldArr(individual)}</>}
            ></CollapsibleComponent>
          )
        })}
    </>
  )
}

export default OverviewIndividuals
